import { API, ApiPrefixes } from "../../api";
const BASE_URL = ApiPrefixes["adminBankSettings"];
const societyBankExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getAllBankInfo: builder.query({
      query: ({ pageNumber = 1 }) =>
        `${BASE_URL}?guard=staff&page=${pageNumber}`,
      transformResponse: (responseData) => {
        const { company_banks = [], pagination = {} } = responseData.data;
        return { company_banks, pagination };
      },
      providesTags: (result = {}) => {
        if (!result?.company_banks) return [{ type: "BankInfo", id: "LIST" }];
        return [
          { type: "BankInfo", id: "LIST" },
          ...result?.company_banks.map(({ bank_id }) => ({
            type: "BankInfo",
            id: bank_id,
          })),
        ];
      },
    }),
    getBankUsage: builder.query({
      query: (bankId) => `${BASE_URL}/${bankId}/usage?guard=staff`,
      transformResponse: (res) => res?.data ?? {},
    }),
    createBankInfo: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/add?guard=staff`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: [
        { type: "BankInfo", id: "LIST" },
        { type: "branch-wallet-balance", id: "BANKS" },
        { type: "AuditLog", id: "LIST" },
        { type: "AuditLog", id: "ACTIONS" },
      ],
    }),
    editBankInfo: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/${body.id}/edit?guard=staff`,
        method: "PATCH",
        body: {
          account_name: body.account_name,
          account_number: body.account_number,
          bank_name: body.bank_name,
          bank_code: body.bank_code,
        },
      }),
      invalidatesTags: [{ type: "BankInfo", id: "LIST" }],
    }),
    configureBankRecipient: builder.mutation({
      query: (bankId) => ({
        url: `${BASE_URL}/${bankId}/configure-recipient?guard=staff`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "BankInfo", id: "LIST" },
        { type: "branch-wallet-balance", id: "BANKS" },
        { type: "AuditLog", id: "LIST" },
        { type: "AuditLog", id: "ACTIONS" },
      ],
    }),
    deleteBankInfo: builder.mutation({
      query: ({ id, replacement_company_bank_id }) => {
        const params = new URLSearchParams({ guard: "staff" });
        if (replacement_company_bank_id) {
          params.append(
            "replacement_company_bank_id",
            String(replacement_company_bank_id)
          );
        }
        return {
          url: `${BASE_URL}/${id}/delete?${params.toString()}`,
          method: "DELETE",
        };
      },
      invalidatesTags: () => [
        { type: "BankInfo", id: "LIST" },
        { type: "branch-wallet-balance", id: "BANKS" },
        { type: "contribution-category", id: "LIST" },
        { type: "AuditLog", id: "LIST" },
        { type: "AuditLog", id: "ACTIONS" },
      ],
    }),
  }),
});

export const {
  useCreateBankInfoMutation,
  useDeleteBankInfoMutation,
  useEditBankInfoMutation,
  useGetAllBankInfoQuery,
  useGetBankUsageQuery,
  useConfigureBankRecipientMutation,
} = societyBankExtendedApi;
